var map = {
	"./feature_buy_en.png": 82466,
	"./feature_buy_id.png": 27724,
	"./feature_buy_my.png": 93573,
	"./feature_buy_ph.png": 1219,
	"./feature_buy_th.png": 80079,
	"./feature_buy_zh.png": 10085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30972;